import React, { useState } from 'react';
import { useRoute, useNavigation } from '@react-navigation/native';

import { formatDate } from '../../../common/utils/utils';
import { ActionDock, Screen } from '../../design/components';
import ServiceRunEditor from './ServiceRunEditor';

const ServiceRunEditorView = () => {
	const route = useRoute();
	const navigation = useNavigation();
	// The child reports its primary action so it renders in the measured Screen dock.
	const [dockProps, setDockProps] = useState(null);

	const serviceRunId = route.params?.serviceRunId;
	const routeId = route.params?.routeId;
	const serviceRunName = route.params?.serviceRunName;
	const seviceRunMachines = route.params?.seviceRunMachines;
	const serviceRunDate = route.params?.serviceRunDate;

	return (
		<Screen
			heading={serviceRunName}
			subheading={
				serviceRunDate
					? `${formatDate(serviceRunDate, 'DAY_MONTHWORD_YEAR')}`
					: 'No date'
			}
			scroll={false}
			dock={dockProps ? <ActionDock hint={dockProps.hint} action={dockProps.action} /> : null}
		>
			<ServiceRunEditor
				initialValues={{ machines: seviceRunMachines }}
				routeId={routeId}
				serviceRunId={serviceRunId}
				navigation={navigation}
				onDockChange={setDockProps}
			/>
		</Screen>
	);
};

export default ServiceRunEditorView;
